import { NgModule } from '@angular/core';
import { DotBackgroundOverlayModule } from '@shared/dot-background-overlay/dot-background-overlay.module';
import { UIModule } from '@shared/ui';
import { StringToIdPipeModule } from '@shared/ui/pipes/string-to-id/string-to-id.module';
import {
  JbChapterSelectorModule,
  JbFlagModule,
  JbHeroModule,
} from 'jb-component-library';

import { PageHeroComponent, pageHeroResolver } from './page-hero.component';

const MODULES = [
  JbHeroModule,
  StringToIdPipeModule,
  UIModule,
  JbChapterSelectorModule,
  JbFlagModule,
  DotBackgroundOverlayModule,
];
@NgModule({
  declarations: [PageHeroComponent],
  imports: [...MODULES],
})
export class PageHeroModule {
  static entry = PageHeroComponent;
  static componentDataResolver = pageHeroResolver;
}
